module.exports = __webpack_public_path__ + "static/media/Involved3.7765cd19.svg";